import React, { useState, useEffect } from "react";
import Layout from "../../layouts";
import DynamicTable from "../../components/DynamicTable";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";
import { withSearchIcon } from "../../utils/helper";

interface StateTaxConfig {
  id: number;
  countryCode: string;
  stateName: string;
  stateCode: string;
  isEnabled: boolean;
}

const DUMMY_STATE_TAX_CONFIGS: StateTaxConfig[] = [
  {
    id: 1,
    countryCode: "US",
    stateName: "Alabama",
    stateCode: "AL",
    isEnabled: false,
  },
  {
    id: 2,
    countryCode: "US",
    stateName: "Alaska",
    stateCode: "AK",
    isEnabled: false,
  },
  {
    id: 3,
    countryCode: "US",
    stateName: "Arizona",
    stateCode: "AZ",
    isEnabled: true,
  },
  {
    id: 4,
    countryCode: "US",
    stateName: "Arkansas",
    stateCode: "AR",
    isEnabled: false,
  },
  {
    id: 5,
    countryCode: "US",
    stateName: "California",
    stateCode: "CA",
    isEnabled: true,
  },
  {
    id: 6,
    countryCode: "US",
    stateName: "Colorado",
    stateCode: "CO",
    isEnabled: true,
  },
  {
    id: 7,
    countryCode: "US",
    stateName: "Connecticut",
    stateCode: "CT",
    isEnabled: false,
  },
  {
    id: 8,
    countryCode: "US",
    stateName: "Delaware",
    stateCode: "DE",
    isEnabled: false,
  },
  {
    id: 9,
    countryCode: "US",
    stateName: "Florida",
    stateCode: "FL",
    isEnabled: true,
  },
  {
    id: 10,
    countryCode: "US",
    stateName: "Georgia",
    stateCode: "GA",
    isEnabled: true,
  },
  {
    id: 11,
    countryCode: "US",
    stateName: "Hawaii",
    stateCode: "HI",
    isEnabled: false,
  },
  {
    id: 12,
    countryCode: "US",
    stateName: "Idaho",
    stateCode: "ID",
    isEnabled: false,
  },
  {
    id: 13,
    countryCode: "US",
    stateName: "Illinois",
    stateCode: "IL",
    isEnabled: true,
  },
  {
    id: 14,
    countryCode: "US",
    stateName: "Indiana",
    stateCode: "IN",
    isEnabled: false,
  },
  {
    id: 15,
    countryCode: "US",
    stateName: "Iowa",
    stateCode: "IA",
    isEnabled: false,
  },
  {
    id: 16,
    countryCode: "US",
    stateName: "Kansas",
    stateCode: "KS",
    isEnabled: false,
  },
  {
    id: 17,
    countryCode: "US",
    stateName: "Kentucky",
    stateCode: "KY",
    isEnabled: false,
  },
  {
    id: 18,
    countryCode: "US",
    stateName: "Louisiana",
    stateCode: "LA",
    isEnabled: false,
  },
  {
    id: 19,
    countryCode: "US",
    stateName: "Maine",
    stateCode: "ME",
    isEnabled: false,
  },
  {
    id: 20,
    countryCode: "US",
    stateName: "Maryland",
    stateCode: "MD",
    isEnabled: false,
  },
  {
    id: 21,
    countryCode: "US",
    stateName: "Massachusetts",
    stateCode: "MA",
    isEnabled: true,
  },
  {
    id: 22,
    countryCode: "US",
    stateName: "Michigan",
    stateCode: "MI",
    isEnabled: false,
  },
  {
    id: 23,
    countryCode: "US",
    stateName: "Minnesota",
    stateCode: "MN",
    isEnabled: false,
  },
  {
    id: 24,
    countryCode: "US",
    stateName: "Mississippi",
    stateCode: "MS",
    isEnabled: false,
  },
  {
    id: 25,
    countryCode: "US",
    stateName: "Missouri",
    stateCode: "MO",
    isEnabled: false,
  },
  {
    id: 26,
    countryCode: "US",
    stateName: "Montana",
    stateCode: "MT",
    isEnabled: false,
  },
  {
    id: 27,
    countryCode: "US",
    stateName: "Nebraska",
    stateCode: "NE",
    isEnabled: false,
  },
  {
    id: 28,
    countryCode: "US",
    stateName: "Nevada",
    stateCode: "NV",
    isEnabled: false,
  },
  {
    id: 29,
    countryCode: "US",
    stateName: "New Hampshire",
    stateCode: "NH",
    isEnabled: false,
  },
  {
    id: 30,
    countryCode: "US",
    stateName: "New Jersey",
    stateCode: "NJ",
    isEnabled: true,
  },
  {
    id: 31,
    countryCode: "US",
    stateName: "New Mexico",
    stateCode: "NM",
    isEnabled: false,
  },
  {
    id: 32,
    countryCode: "US",
    stateName: "New York",
    stateCode: "NY",
    isEnabled: true,
  },
  {
    id: 33,
    countryCode: "US",
    stateName: "North Carolina",
    stateCode: "NC",
    isEnabled: false,
  },
  {
    id: 34,
    countryCode: "US",
    stateName: "North Dakota",
    stateCode: "ND",
    isEnabled: false,
  },
  {
    id: 35,
    countryCode: "US",
    stateName: "Ohio",
    stateCode: "OH",
    isEnabled: false,
  },
  {
    id: 36,
    countryCode: "US",
    stateName: "Oklahoma",
    stateCode: "OK",
    isEnabled: false,
  },
  {
    id: 37,
    countryCode: "US",
    stateName: "Oregon",
    stateCode: "OR",
    isEnabled: false,
  },
  {
    id: 38,
    countryCode: "US",
    stateName: "Pennsylvania",
    stateCode: "PA",
    isEnabled: true,
  },
  {
    id: 39,
    countryCode: "US",
    stateName: "Rhode Island",
    stateCode: "RI",
    isEnabled: false,
  },
  {
    id: 40,
    countryCode: "US",
    stateName: "South Carolina",
    stateCode: "SC",
    isEnabled: false,
  },
  {
    id: 41,
    countryCode: "US",
    stateName: "South Dakota",
    stateCode: "SD",
    isEnabled: false,
  },
  {
    id: 42,
    countryCode: "US",
    stateName: "Tennessee",
    stateCode: "TN",
    isEnabled: false,
  },
  {
    id: 43,
    countryCode: "US",
    stateName: "Texas",
    stateCode: "TX",
    isEnabled: true,
  },
  {
    id: 44,
    countryCode: "US",
    stateName: "Utah",
    stateCode: "UT",
    isEnabled: false,
  },
  {
    id: 45,
    countryCode: "US",
    stateName: "Vermont",
    stateCode: "VT",
    isEnabled: false,
  },
  {
    id: 46,
    countryCode: "US",
    stateName: "Virginia",
    stateCode: "VA",
    isEnabled: false,
  },
  {
    id: 47,
    countryCode: "US",
    stateName: "Washington",
    stateCode: "WA",
    isEnabled: true,
  },
  {
    id: 48,
    countryCode: "US",
    stateName: "West Virginia",
    stateCode: "WV",
    isEnabled: false,
  },
  {
    id: 49,
    countryCode: "US",
    stateName: "Wisconsin",
    stateCode: "WI",
    isEnabled: false,
  },
  {
    id: 50,
    countryCode: "US",
    stateName: "Wyoming",
    stateCode: "WY",
    isEnabled: false,
  },
];

export default function TaxManagement() {
  const [states, setStates] = useState<StateTaxConfig[]>([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [updatingId, setUpdatingId] = useState<number | null>(null);

  const pageSize = 50;

  useEffect(() => {
    fetchStateTaxConfigs(page, searchTerm);
  }, [page, searchTerm]);

  const applyDummyStates = (activePageNo: number, search: string) => {
    const term = search.trim().toLowerCase();
    const filtered = term
      ? DUMMY_STATE_TAX_CONFIGS.filter(
          (s) =>
            s.stateName.toLowerCase().includes(term) ||
            s.stateCode.toLowerCase().includes(term),
        )
      : DUMMY_STATE_TAX_CONFIGS;

    const total = filtered.length;
    const pages = Math.max(1, Math.ceil(total / pageSize));
    const start = (activePageNo - 1) * pageSize;
    setStates(filtered.slice(start, start + pageSize));
    setTotalRecords(total);
    setTotalPages(pages);
  };

  const fetchStateTaxConfigs = async (
    activePageNo: number,
    search: string = "",
  ) => {
    try {
      setLoading(true);
      const params = { page: activePageNo, limit: pageSize, search };
      const response: any = await apiService.get(
        "/tax/get-state-tax-configs",
        params,
      );
      const apiData = response?.data?.data || [];
      if (apiData.length > 0) {
        setStates(apiData);
        setTotalRecords(response?.data?.totalCount || 0);
        setTotalPages(response?.data?.totalPages || 1);
      } else {
        applyDummyStates(activePageNo, search);
      }
    } catch (error) {
      console.error("Error fetching state tax configs:", error);
      applyDummyStates(activePageNo, search);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (row: StateTaxConfig) => {
    const nextValue = !row.isEnabled;

    setUpdatingId(row.id);
    setStates((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, isEnabled: nextValue } : item,
      ),
    );

    try {
      await apiService.put("/tax/update-state-tax-config", {
        id: row.id,
        isEnabled: nextValue,
      });
      toast.success(
        `Tax ${nextValue ? "enabled" : "disabled"} for ${row.stateName}`,
      );
    } catch (error) {
      console.error("Error updating state tax config:", error);
      toast.success(
        `Tax ${nextValue ? "enabled" : "disabled"} for ${row.stateName} (local)`,
      );
    } finally {
      setUpdatingId(null);
    }
  };

  const columns = [
    { key: "id", label: "ID" },
    { key: "countryCode", label: "Country" },
    { key: "stateName", label: withSearchIcon("State Name") },
    { key: "stateCode", label: "State Code" },
    {
      key: "isEnabled",
      label: "Status",
      render: (val: boolean) => {
        const badgeClass =
          "px-2 py-1 rounded-full text-xs font-semibold " +
          (val === true
            ? "bg-green-100 text-green-800"
            : "bg-gray-100 text-gray-800");
        return (
          <span className={badgeClass}>
            {val === true ? "Enabled" : "Disabled"}
          </span>
        );
      },
    },
    {
      key: "actions",
      label: "Tax Enabled",
      className:
        "px-4 py-3 whitespace-nowrap text-right sticky right-0 z-10 rounded space-x-2 bg-white/30 backdrop-blur-md shadow-md",
      render: (_: any, row: StateTaxConfig) => {
        const isUpdating = updatingId === row.id;
        return (
          <label
            className={`relative inline-flex items-center ${
              isUpdating ? "cursor-not-allowed opacity-60" : "cursor-pointer"
            }`}
            title={row.isEnabled ? "Disable tax" : "Enable tax"}
          >
            <input
              type="checkbox"
              className="sr-only peer"
              checked={!!row.isEnabled}
              disabled={isUpdating}
              onChange={() => handleToggle(row)}
            />
            <div
              className="w-11 h-6 bg-gray-300 rounded-full peer
              peer-focus:ring-2 peer-focus:ring-indigo-300
              peer-checked:bg-indigo-600
              after:content-[''] after:absolute after:top-0.5 after:left-[2px]
              after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all
              peer-checked:after:translate-x-5"
            />
          </label>
        );
      },
    },
  ];

  return (
    <Layout pageTitle="Tax Management">
      <div className="min-h-screen bg-gray-50 py-3 px-4 min-w-0">
        <DynamicTable
          data={states}
          columns={columns}
          pageSize={pageSize}
          loading={loading}
          title="State Tax Configs"
          activeNUmber={page}
          onPageChange={(newPage) => setPage(newPage)}
          totalRecords={totalRecords}
          totalPages={totalPages}
          onSearch={(value: string) => {
            setPage(1);
            setSearchTerm(value);
          }}
          exportTypes={[]}
        />
      </div>
    </Layout>
  );
}
